import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["inputClassName", "defaultValue", "currencyLabel", "label", "onChange", "lang", "errorLabel", "maxLength", "disallowZero", "inputContainerClassName", "labelClassName"];
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import stl from "./InputCurrency.module.css";
import useIsIOS from "@hooks/useIsIOS";
var InputCurrency = function InputCurrency(_ref) {
  var inputClassName = _ref.inputClassName,
    defaultValue = _ref.defaultValue,
    currencyLabel = _ref.currencyLabel,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Currency" : _ref$label,
    onChange = _ref.onChange,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "ar" : _ref$lang,
    errorLabel = _ref.errorLabel,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 11 : _ref$maxLength,
    _ref$disallowZero = _ref.disallowZero,
    disallowZero = _ref$disallowZero === void 0 ? false : _ref$disallowZero,
    inputContainerClassName = _ref.inputContainerClassName,
    labelClassName = _ref.labelClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var isIos = useIsIOS();
  var _useState = useState(""),
    displayValue = _useState[0],
    setDisplayValue = _useState[1];
  var _useState2 = useState(false),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  useEffect(function () {
    // Update display value whenever defaultValue changes
    if (defaultValue !== undefined && defaultValue !== null) {
      if (!disallowZero || disallowZero && defaultValue !== 0) {
        setDisplayValue(defaultValue === 0 ? "" : formatWithCommas(defaultValue.toString()));
        setHasError(false);
      } else {
        setDisplayValue("");
        setHasError(true);
      }
    }
  }, [defaultValue, disallowZero]);

  // Helper to normalize input (convert Arabic numerals to English numerals)
  var normalizeInput = function normalizeInput(input) {
    var arabicToEnglishMap = {
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9"
    };
    var numericValue = input.replace(/[٠-٩]/g, function (_char) {
      return arabicToEnglishMap[_char] || _char;
    }) // Arabic to English
    .replace(/[^0-9]/g, ""); // Remove non-numeric characters

    return numericValue.slice(0, maxLength); // Enforce max length
  };

  // Helper to format number with commas
  var formatWithCommas = function formatWithCommas(input) {
    var numericValue = normalizeInput(input);
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Handle input changes
  var handleInputChange = function handleInputChange(e) {
    //prevent from changing if the value is zero and the disallowZero is true
    if ((e.target.value === "0" || e.target.value === "٠") && disallowZero) {
      return;
    }
    var rawValue = normalizeInput(e.target.value);
    var numericValue = parseFloat(rawValue);
    if (rawValue === "") {
      onChange(0);
      return;
    }
    var formattedValue = formatWithCommas(rawValue);
    setDisplayValue(formattedValue);
    setHasError(false);
    onChange(numericValue);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: stl.inputWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.inputContainer, " ").concat(displayValue ? stl.focused : "", " ").concat(inputContainerClassName !== null && inputContainerClassName !== void 0 ? inputContainerClassName : "", " ").concat(hasError ? stl.error : "")
  }, /*#__PURE__*/React.createElement("label", {
    className: "".concat(stl.label, " ").concat(labelClassName !== null && labelClassName !== void 0 ? labelClassName : "")
  }, label), /*#__PURE__*/React.createElement("input", _extends({
    type: "text" // Always use "text" to handle formatted display
    ,
    inputMode: "numeric",
    pattern: "[0-9]*" // Allow only numeric input
    ,
    className: "".concat(stl.inputField, " ").concat(inputClassName !== null && inputClassName !== void 0 ? inputClassName : ""),
    value: displayValue // Display formatted value
    ,
    onChange: handleInputChange // Format and enforce max length
  }, props)), currencyLabel && /*#__PURE__*/React.createElement("span", {
    className: stl.currencyLabel
  }, currencyLabel)), errorLabel && hasError && /*#__PURE__*/React.createElement("span", {
    className: stl.errorLabel
  }, errorLabel));
};
export default InputCurrency;